import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FormattedMessage } from 'react-intl';
import { defineStyles } from '../theme';
const styles = defineStyles({
    content: {
        display: 'flex',
        flexDirection: 'column',
    },
    strongContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },
});
export const InfoDialog = ({ open, onOk, onClose, title, content, okButtonColor, okButtonText, sx, }) => (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: "sm", fullWidth: true, sx: sx, children: [_jsx(DialogTitle, { children: title }), _jsx(DialogContent, { sx: styles.content, children: content }), _jsx(DialogActions, { children: _jsx(Button, { onClick: onOk, color: okButtonColor ?? 'primary', children: okButtonText ?? _jsx(FormattedMessage, { id: "common.ok.button", defaultMessage: "OK" }) }) })] }));
//# sourceMappingURL=InfoDialog.js.map